export const getLastParamUrl = () => {
	const urlSplit = window.location.href.split("/");

	return urlSplit[urlSplit.length - 1];
};